import { render, staticRenderFns } from "./registeringItem.vue?vue&type=template&id=344d729a&scoped=true&"
import script from "./registeringItem.vue?vue&type=script&lang=js&"
export * from "./registeringItem.vue?vue&type=script&lang=js&"
import style0 from "./registeringItem.vue?vue&type=style&index=0&id=344d729a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344d729a",
  null
  
)

export default component.exports